import type { SelectedPerimeters } from "@contexts/SelectedPerimeters/SelectedPerimeters.types";
import type { PerimeterExported } from "@services/apiEcms/apiEcms.types";

export const getPerimeterExported = (
  selectedPerimeters: SelectedPerimeters[],
) => {
  const hasContracts = selectedPerimeters.some((item) => item.contractId);

  if (!hasContracts) {
    return selectedPerimeters.map(({ customerId }) => ({ customerId }));
  }

  const grouped = selectedPerimeters.reduce<PerimeterExported[]>(
    (acc, curr) => {
      const existing = acc.find((item) => item.customerId === curr.customerId);

      if (existing && curr.contractId) {
        existing.contracts?.push({ contractId: curr.contractId });
      } else if (curr.contractId) {
        acc.push({
          customerId: curr.customerId,
          contracts: [{ contractId: curr.contractId }],
        });
      }

      return acc;
    },
    [],
  );

  return grouped;
};
